import { Injectable, signal, WritableSignal } from "@angular/core";
import uuid from "uuid";

/**
 * Service that holds options to be used for the metrics service.
 * Allows for holding references of specific data that may be required cross compoents.
 */
@Injectable({ providedIn: 'root' })
export class MetricsOptionsService {

    //#region Signals

    private _source: WritableSignal<string | null> = signal(null);
    private flowInstanceId: string | null;

    //#endregion

    //#region Variables

    public readonly source = this._source.asReadonly();

    //#endregion

    //#region Public Methods

    public setSource(source: string | null) { this._source.set(source); }

    public getFlowInstanceId(reset: boolean = false): string {
        if (reset) {
            this.flowInstanceId = null;
        }
        if (!this.flowInstanceId) {
            this.flowInstanceId = uuid();
        }
        return this.flowInstanceId;
    }

    //#endregion
}